import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "tr" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "标题", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "tr" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "类型", -1)
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "案号", -1)
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "tr" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "立案日期", -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "原文链接", -1)
const _hoisted_19 = { class: "value" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "tr" }
const _hoisted_22 = { class: "item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "内容详情", -1)
const _hoisted_24 = { class: "value" }
const _hoisted_25 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.d.title || '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.d.type || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.d.caseNo || '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.toDate(_ctx.d.judgeDate,"YYYY-MM-DD")), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("a", {
              href: _ctx.d.originalUrl,
              target: "_blank"
            }, "查看原文", 8, _hoisted_20)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = true)),
              href: "javascipt:;"
            }, "查看")
          ])
        ])
      ])
    ], 512), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: _ctx.d.title,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          innerHTML: _ctx.d.conent
        }, null, 8, _hoisted_25)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}